import { Tooltip } from 'antd'
import { type CSSProperties, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import iconBackButton from 'assets/icons/backButton.svg'
import iconBackButtonWhite from 'assets/icons/backButonWhite.svg'
import { Device } from '../Device'
import IconSearch from '../Icons/Search'
import IconShare from '../Icons/Share'
import ModalShare from '../ModalShare'

import './styles.scss'
import { useAccessibility } from 'context/hooks/useAccessibility'
import { getOverlayCustomTooltip } from 'utils/utils'
interface TitlePageProps {
  title?: string
  subtitle?: string

  style?: CSSProperties
}
function TitlePage({ title, subtitle, style }: TitlePageProps) {
  const navigate = useNavigate()

  const device = Device.useDevice()

  const devicePrefix = device.prefix()

  const [showModal, setShowModal] = useState(false)

  const { contrastIsSelected } = useAccessibility()

  const overlayStyle = getOverlayCustomTooltip(contrastIsSelected)

  return (
    <main
      className={`container-titlePage ${devicePrefix ?? 'undefined'}`}
      style={style}
    >
      <button
        onClick={() => {
          navigate(-1)
        }}
      >
        <img
          src={contrastIsSelected ? iconBackButtonWhite : iconBackButton}
          alt="button preview"
        />
      </button>

      <div className="container-titlePage__title">
        <h1>{title?.toLowerCase() ?? 'Não tem informação'}</h1>
        {subtitle !== undefined && <h3>{subtitle}</h3>}
      </div>
      <div className="container-titlePage__interactions">
        <Tooltip
          placement="bottom"
          title={'Nova pesquisa'}
          overlayStyle={overlayStyle}
        >
          <Link to={'/pesquisa'}>
            <IconSearch />
          </Link>
        </Tooltip>
        <Tooltip
          placement="bottom"
          title={'Compartilhar'}
          overlayStyle={overlayStyle}
        >
          <button
            id="url"
            onClick={() => {
              setShowModal(true)
            }}
          >
            <IconShare />
          </button>
        </Tooltip>
      </div>

      {showModal && (
        <ModalShare showModal={showModal} setShowModal={setShowModal} />
      )}
    </main>
  )
}

export default TitlePage
